export function getHrefBasePath(href: string): string {
    const url = new URL(href);
    let path = url.pathname;
    if (path[path.length - 1] === '/') {
        path = path.substring(0, path.length - 1);
    }
    const pathSegments = path.split('/');
    if (pathSegments[pathSegments.length - 1].includes('.htm')) {
        pathSegments.pop();
        path = pathSegments.join('/');
    }

    return url.origin + path;
}
